export default function Tickets({ticketCost}){
    return(
        <div className="d-flex align-items-center">
        <i className="ti-wallet text-primary icon-md mr-2" />
        <div className="text-left">
          <h6 className="mb-0">PRICE</h6>
          <p className="mb-0">{ticketCost}</p>
        </div>
    </div>)
}
